import React, { useEffect, useState, useRef } from "react";
import Sidebar from "../components/Sidebar";
import CircleIcon from "@mui/icons-material/Circle";
import { useNavigate } from "react-router-dom";
import PanToolIcon from "@mui/icons-material/PanTool";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useDispatch, useSelector } from "react-redux";
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import {
  adaptionStatusComplete,
  adaptionStatusStart,
  adminActions,
  assignAdaptionToStaffMember,
  assignJobToStaffMember,
  deleteApproveAdaptionQoutes,
  deleteApproveQoutes,
  fetchAdminApprovedAdaptionQoutesLiveProject,
  fetchAdminApprovedQoutesLiveProject,
  fetchAdminApprovedQoutesLiveProjectMap,
  fetchJobsForStaffMember,
  fetchKeyStaffMember,
  jobStatusComplete,
  jobStatusStart,
  signOut,
} from "../store/adminSlice";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import moment from "moment";
import UpdateIcon from "@mui/icons-material/Update";
import HeaderScaff from "../components/HeaderScaff";
import { useMediaQuery } from "@mui/material";
import HomeWorkIcon from "@mui/icons-material/HomeWork";
import Swal from "sweetalert2";
import $ from "jquery";
import MapIcon from "@mui/icons-material/Map";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
$.DataTable = require("datatables.net");

function LiveProjects() {
  const isNonMobile = useMediaQuery("(min-width: 768px)");
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [needed, setNeeded] = useState(true);
  const [showMap, setShowMap] = useState(false);
  const [mapLoading, setMapLoading] = useState(false);
  const [mapData, setMapData] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const stateApprovedQoutes = useSelector(
    (state) => state.admin.adminApprovedQoutes
  );
  const stateadminApprovedAdaptionQoutes = useSelector(
    (state) => state.admin.adminApprovedAdaptionQoutes
  );
  const stateAdminApprovedQoutesLiveProjectMap = useSelector(
    (state) => state.admin.adminApprovedQoutesLiveProjectMap
  );
  const statekeyMemberStaff = useSelector(
    (state) => state.admin.keyMemberStaff
  );
  const jobforStaffMember = useSelector(
    (state) => state.admin.jobforStaffMember
  );
  const _id = useSelector((state) => state.admin._id);
  const subscribed = useSelector((state) => state.admin.subscribed);
  const statesignOut = useSelector((state) => state.admin.signOut);

  // Fetch map data from backend using Redux
  const fetchMapData = () => {
    setMapLoading(true);
    // Dispatch Redux action to fetch map data
    dispatch(fetchAdminApprovedQoutesLiveProjectMap({ adminID: _id }));
  };

  // Process map data when Redux state changes
  useEffect(() => {
    if (stateAdminApprovedQoutesLiveProjectMap && Array.isArray(stateAdminApprovedQoutesLiveProjectMap)) {
      // Filter projects that have geocoding data for map display
      const projectsWithLocation = stateAdminApprovedQoutesLiveProjectMap.filter(project => {
        return project.geocoding && 
               project.geocoding.latitude && 
               project.geocoding.longitude &&
               project.jobID;
      }).map(project => {
        return {
          _id: project.jobID._id,
          jobNumber: project.jobID.jobNumber,
          customerCompanyName: project.customerID?.customerCompanyName || 'N/A',
          address: `${project.jobID.job1} ${project.jobID.job2 || ''}`.trim(),
          postCode: project.jobID.postCode,
          status: project.jobID.status,
          geocoding: project.geocoding,
          staffMember: project.staffMemberID || null,
          dateOfErection: project.dateOfErection,
          jobDescription: project.jobID.jobDescription,
          dismantleDate: project.dismantleRequestedDate,
          partialDismantleDescription: project.partialDismantleDescription
        };
      });

      // Group projects by same coordinates
      const groupedProjects = {};
      projectsWithLocation.forEach(project => {
        const key = `${project.geocoding.latitude},${project.geocoding.longitude}`;
        if (!groupedProjects[key]) {
          groupedProjects[key] = [];
        }
        groupedProjects[key].push(project);
      });

      // Convert grouped projects to map data with location clusters
      const mapDataWithClusters = Object.entries(groupedProjects).map(([coordinates, projects]) => {
        const [lat, lng] = coordinates.split(',').map(Number);
        return {
          coordinates: { latitude: lat, longitude: lng },
          projects: projects,
          projectCount: projects.length,
          // Use the first project's geocoding info for display
          geocoding: projects[0].geocoding,
          // Show mixed status if multiple projects with different statuses
          mixedStatus: projects.length > 1 ? [...new Set(projects.map(p => p.status))] : [projects[0].status]
        };
      });

      setMapData(mapDataWithClusters);
      setMapLoading(false);
    }
  }, [stateAdminApprovedQoutesLiveProjectMap]);

  // Handle show/hide map toggle
  const handleMapToggle = () => {
    if (!showMap) {
      // If showing map for the first time, fetch data
      setShowMap(true);
      fetchMapData();
    } else {
      // If hiding map, just close it
      setShowMap(false);
    }
  };

  // Custom marker icons için gerekli olan leaflet icon fix
  useEffect(() => {
    delete L.Icon.Default.prototype._getIconUrl;
    L.Icon.Default.mergeOptions({
      iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
      iconUrl: require('leaflet/dist/images/marker-icon.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });
  }, []);

  // Custom marker icon oluşturmak için yardımcı fonksiyonlar
  const getMarkerStyles = (status, needsDismantle = false) => {
    // Priority: Dismantle needed overrides normal status
    if (needsDismantle) {
      return {
        backgroundColor: '#FEE2E2',
        borderColor: '#DC2626',
        textColor: '#991B1B',
        icon: '🔨',
        size: 30,
        borderWidth: 3,
        animation: `
          @keyframes urgent {
            0% { 
              transform: scale(1); 
              box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.7);
            }
            50% { 
              transform: scale(1.1); 
              box-shadow: 0 0 0 10px rgba(220, 38, 38, 0);
            }
            100% { 
              transform: scale(1); 
              box-shadow: 0 0 0 0 rgba(220, 38, 38, 0);
            }
          }
          animation: urgent 1.5s infinite;
        `
      };
    }

    switch (status) {
      case 0: // Pending - Yellow with pulse animation
        return {
          backgroundColor: '#FEF3C7',
          borderColor: '#F59E0B',
          textColor: '#92400E',
          icon: '⏳',
          size: 28,
          borderWidth: 3,
          animation: `
            @keyframes pulse {
              0% { 
                transform: scale(1); 
                box-shadow: 0 0 0 0 rgba(245, 158, 11, 0.7);
              }
              70% { 
                transform: scale(1.1); 
                box-shadow: 0 0 0 8px rgba(245, 158, 11, 0);
              }
              100% { 
                transform: scale(1); 
                box-shadow: 0 0 0 0 rgba(245, 158, 11, 0);
              }
            }
            animation: pulse 2s infinite;
          `
        };
      case 1: // In Progress - Blue with rotate animation
        return {
          backgroundColor: '#BFDBFE',
          borderColor: '#3B82F6',
          textColor: '#1E40AF',
          icon: '🔄',
          size: 26,
          borderWidth: 3,
          animation: `
            @keyframes rotate {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }
            animation: rotate 3s linear infinite;
          `
        };
      case 2: // Completed - Green with glow
        return {
          backgroundColor: '#D1FAE5',
          borderColor: '#10B981',
          textColor: '#065F46',
          icon: '✅',
          size: 24,
          borderWidth: 2,
          animation: `
            @keyframes glow {
              0%, 100% { 
                box-shadow: 0 0 5px rgba(16, 185, 129, 0.5);
              }
              50% { 
                box-shadow: 0 0 15px rgba(16, 185, 129, 0.8);
              }
            }
            animation: glow 4s ease-in-out infinite;
          `
        };
      default:
        return {
          backgroundColor: '#F3F4F6',
          borderColor: '#9CA3AF',
          textColor: '#6B7280',
          icon: '❓',
          size: 22,
          borderWidth: 2,
          animation: ''
        };
    }
  };

  const createCustomMarkerIcon = (cluster) => {
    const isMultipleProjects = cluster.projectCount > 1;
    const uniqueId = `${cluster.coordinates.latitude}-${cluster.coordinates.longitude}`;
    
    // Check if any project in cluster needs dismantling
    const hasDismantle = cluster.projects.some(project => project.dismantleDate);
    
    if (isMultipleProjects) {
      // Multiple projects - show count and mixed colors
      const hasMultipleStatuses = cluster.mixedStatus.length > 1;
      
      // If any project needs dismantling, prioritize red styling
      const backgroundColor = hasDismantle ? 
        'linear-gradient(135deg, #FEE2E2 0%, #FECACA 50%, #FCA5A5 100%)' : 
        hasMultipleStatuses ? 
          'linear-gradient(135deg, #FEF3C7 0%, #BFDBFE 50%, #D1FAE5 100%)' : 
          '#D1FAE5';
      
      const borderColor = hasDismantle ? '#DC2626' : '#66c18a';
      const textColor = hasDismantle ? '#991B1B' : '#065F46';
      const animation = hasDismantle ? 'urgent 1.5s infinite' : 'pulse 2s infinite';
      
      return L.divIcon({
        html: `
          <style>
            .custom-marker-${uniqueId} {
              transition: all 0.3s ease;
              animation: ${animation};
            }
            .custom-marker-${uniqueId}:hover {
              transform: scale(1.2) !important;
              z-index: 1000;
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
            }
            @keyframes pulse {
              0% { 
                transform: scale(1); 
                box-shadow: 0 0 0 0 rgba(102, 193, 138, 0.7);
              }
              70% { 
                transform: scale(1.05); 
                box-shadow: 0 0 0 8px rgba(102, 193, 138, 0);
              }
              100% { 
                transform: scale(1); 
                box-shadow: 0 0 0 0 rgba(102, 193, 138, 0);
              }
            }
            @keyframes urgent {
              0% { 
                transform: scale(1); 
                box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.7);
              }
              50% { 
                transform: scale(1.1); 
                box-shadow: 0 0 0 10px rgba(220, 38, 38, 0);
              }
              100% { 
                transform: scale(1); 
                box-shadow: 0 0 0 0 rgba(220, 38, 38, 0);
              }
            }
          </style>
          <div class="custom-marker-${uniqueId}" style="
            background: ${backgroundColor};
            border: 3px solid ${borderColor};
            border-radius: 50%;
            width: 32px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-weight: bold;
            color: ${textColor};
            cursor: pointer;
            position: relative;
            z-index: 10;
          ">
            ${hasDismantle ? '🔨' : cluster.projectCount}
          </div>
        `,
        className: 'custom-marker-cluster',
        iconSize: [32, 32],
        iconAnchor: [16, 16]
      });
    } else {
      // Single project - use original styling
      const project = cluster.projects[0];
      const needsDismantle = project.dismantleDate;
      const markerStyle = getMarkerStyles(project.status, needsDismantle);
      
      return L.divIcon({
        html: `
          <style>
            .custom-marker-${uniqueId} {
              ${markerStyle.animation}
              transition: all 0.3s ease;
            }
            .custom-marker-${uniqueId}:hover {
              transform: scale(1.2) !important;
              z-index: 1000;
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3) !important;
            }
          </style>
          <div class="custom-marker-${uniqueId}" style="
            background-color: ${markerStyle.backgroundColor};
            border: ${markerStyle.borderWidth}px solid ${markerStyle.borderColor};
            border-radius: 50%;
            width: ${markerStyle.size}px;
            height: ${markerStyle.size}px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: ${markerStyle.size * 0.5}px;
            font-weight: bold;
            color: ${markerStyle.textColor};
            cursor: pointer;
            position: relative;
            z-index: 10;
          ">
            ${markerStyle.icon}
          </div>
        `,
        className: 'custom-marker',
        iconSize: [markerStyle.size, markerStyle.size],
        iconAnchor: [markerStyle.size / 2, markerStyle.size / 2]
      });
    }
  };

  // Popup içeriği oluşturmak için yardımcı fonksiyon
  const getStatusBadgeStyle = (status, needsDismantle = false) => {
    // Priority: Dismantle needed overrides normal status
    if (needsDismantle) {
      return 'background: linear-gradient(45deg, #FEE2E2, #FECACA); color: #991B1B; animation: urgent 1.5s infinite;';
    }

    switch (status) {
      case 0:
        return 'background: linear-gradient(45deg, #FEF3C7, #FDE68A); color: #92400E; animation: pulse 2s infinite;';
      case 1:
        return 'background: linear-gradient(45deg, #BFDBFE, #93C5FD); color: #1E40AF;';
      case 2:
        return 'background: linear-gradient(45deg, #D1FAE5, #A7F3D0); color: #065F46;';
      default:
        return 'background: #F3F4F6; color: #6B7280;';
    }
  };

  const createPopupContent = (cluster) => {
    const isMultipleProjects = cluster.projectCount > 1;
    
    if (isMultipleProjects) {
      // Multiple projects at same location
      const locationInfo = cluster.geocoding;
      
      return `
        <div style="min-width: 280px; max-width: 320px; font-family: system-ui; border-radius: 8px; overflow: hidden;">
          <div style="background: linear-gradient(135deg, #66c18a, #4ade80); color: white; padding: 12px; margin: -8px -8px 8px -8px;">
            <h3 style="margin: 0; font-size: 16px; font-weight: 700; text-shadow: 0 1px 2px rgba(0,0,0,0.1);">
              📍 ${cluster.projectCount} Projects at this location
            </h3>
            <div style="font-size: 11px; margin-top: 4px; opacity: 0.9;">
              ${locationInfo.postcode || 'N/A'} - ${locationInfo.admin_district || 'N/A'}
            </div>
          </div>
          
          <div style="padding: 4px; max-height: 300px; overflow-y: auto;">
            ${cluster.projects.map((project, index) => `
              <div style="
                border: 1px solid ${index === 0 ? '#E5E7EB' : '#F3F4F6'}; 
                border-radius: 6px; 
                padding: 8px; 
                margin-bottom: ${index === cluster.projects.length - 1 ? '0' : '6px'};
                background: ${index % 2 === 0 ? '#FAFAFA' : '#FFFFFF'};
              ">
                                 <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;">
                   <div style="font-weight: 600; color: #374151; font-size: 13px;">
                     ${project.customerCompanyName || 'N/A'}
                   </div>
                   <span style="
                     padding: 2px 8px; 
                     border-radius: 12px; 
                     font-size: 10px; 
                     font-weight: 600;
                     ${getStatusBadgeStyle(project.status, project.dismantleDate)}
                     border: 1px solid ${project.dismantleDate ? '#DC2626' : project.status === 0 ? '#F59E0B' : project.status === 1 ? '#3B82F6' : '#10B981'};
                   ">
                     ${project.dismantleDate ? '🔨 DISMANTLE' : project.status === 0 ? '⏳ PENDING' : project.status === 1 ? '🔄 PROGRESS' : '✅ DONE'}
                   </span>
                 </div>
                
                <div style="font-size: 11px; color: #6B7280; margin-bottom: 4px;">
                  <span style="font-weight: 600;">Job #${project.jobNumber}</span> | 
                  <span style="font-weight: 600;">${project.address}</span>
                </div>
                
                                 <div style="font-size: 10px; color: #9CA3AF; margin-bottom: 4px;">
                   ${project.jobDescription || 'No description'}
                 </div>
                 
                 ${project.dismantleDate ? `
                   <div style="font-size: 10px; color: #DC2626; margin-bottom: 4px; font-weight: 600;">
                     🔨 <span style="font-weight: 700;">Dismantle Date:</span> ${new Date(project.dismantleDate).toLocaleDateString('en-GB')}
                   </div>
                 ` : ''}
                 
                 ${project.staffMember ? `
                   <div style="font-size: 10px; color: #6B7280;">
                     👤 <span style="font-weight: 600;">${project.staffMember.fullName}</span>
                     ${project.staffMember.email ? ` | ${project.staffMember.email}` : ''}
                   </div>
                 ` : `
                   <div style="font-size: 10px; color: #EF4444; font-style: italic;">
                     👤 No staff assigned
                   </div>
                 `}
              </div>
            `).join('')}
          </div>
        </div>
      `;
    } else {
      // Single project
      const project = cluster.projects[0];
      
      return `
        <div style="min-width: 220px; font-family: system-ui; border-radius: 8px; overflow: hidden;">
          <div style="background: linear-gradient(135deg, #66c18a, #4ade80); color: white; padding: 12px; margin: -8px -8px 8px -8px;">
            <h3 style="margin: 0; font-size: 16px; font-weight: 700; text-shadow: 0 1px 2px rgba(0,0,0,0.1);">
              ${project.customerCompanyName || 'N/A'}
            </h3>
          </div>
          
          <div style="padding: 4px;">
            <div style="display: flex; justify-content: space-between; margin-bottom: 8px; align-items: center;">
              <div>
                <span style="font-weight: 600; color: #374151; font-size: 12px;">Job ID:</span>
                <div style="color: #6B7280; font-weight: 600;">${project.jobNumber || 'N/A'}</div>
              </div>
              
              <span style="
                padding: 4px 12px; 
                border-radius: 20px; 
                font-size: 11px; 
                font-weight: 700;
                ${getStatusBadgeStyle(project.status, project.dismantleDate)}
                border: 2px solid ${project.dismantleDate ? '#DC2626' : project.status === 0 ? '#F59E0B' : project.status === 1 ? '#3B82F6' : '#10B981'};
              ">
                ${project.dismantleDate ? '🔨 DISMANTLE NEEDED' : project.status === 0 ? '⏳ PENDING' : project.status === 1 ? '🔄 IN PROGRESS' : '✅ COMPLETED'}
              </span>
            </div>
            
            <div style="margin-bottom: 6px;">
              <span style="font-weight: 600; color: #374151; font-size: 12px;">📍 Address:</span>
              <div style="color: #6B7280; font-size: 11px; margin-top: 2px; line-height: 1.3;">
                ${project.address || 'N/A'}
              </div>
            </div>
            
            <div style="margin-bottom: 6px;">
              <span style="font-weight: 600; color: #374151; font-size: 12px;">📮 Postcode:</span>
              <span style="color: #6B7280; margin-left: 4px; font-weight: 600;">${project.postCode || 'N/A'}</span>
            </div>

            ${project.geocoding.admin_district ? `
              <div style="margin-bottom: 6px;">
                <span style="font-weight: 600; color: #374151; font-size: 12px;">🏛️ District:</span>
                <span style="color: #6B7280; margin-left: 4px;">${project.geocoding.admin_district}</span>
              </div>
            ` : ''}

            ${project.dismantleDate ? `
              <div style="margin-bottom: 6px;">
                <span style="font-weight: 600; color: #374151; font-size: 12px;">🔨 Dismantle Date:</span>
                <span style="color: #DC2626; margin-left: 4px; font-weight: 600;">${new Date(project.dismantleDate).toLocaleDateString('en-GB')}</span>
              </div>
            ` : ''}

            ${project.staffMember ? `
              <div style="margin-bottom: 6px;">
                <span style="font-weight: 600; color: #374151; font-size: 12px;">👤 Staff:</span>
                <div style="color: #6B7280; font-size: 11px; margin-top: 2px; line-height: 1.3;">
                  <div style="font-weight: 600;">${project.staffMember.fullName || 'N/A'}</div>
                  ${project.staffMember.email ? `<div style="color: #9CA3AF; font-size: 10px;">${project.staffMember.email}</div>` : ''}
                  ${project.staffMember.telephone ? `<div style="color: #9CA3AF; font-size: 10px;">📞 ${project.staffMember.telephone}</div>` : ''}
                </div>
              </div>
            ` : `
              <div style="margin-bottom: 6px;">
                <span style="font-weight: 600; color: #374151; font-size: 12px;">👤 Staff:</span>
                <span style="color: #EF4444; margin-left: 4px; font-size: 11px; font-style: italic;">Not assigned</span>
              </div>
            `}
   
          </div>
        </div>
      `;
    }
  };

  // Map controller component to handle automatic focusing
  const MapController = ({ mapData }) => {
    const map = useMap();
    
    useEffect(() => {
      if (mapData && mapData.length > 0) {
        // Calculate bounds for all project locations
        const bounds = [];
        mapData.forEach(cluster => {
          if (cluster.coordinates && cluster.coordinates.latitude && cluster.coordinates.longitude) {
            bounds.push([cluster.coordinates.latitude, cluster.coordinates.longitude]);
          }
        });
        
        if (bounds.length > 0) {
          // If only one location, center and zoom to it
          if (bounds.length === 1) {
            map.setView(bounds[0], 12);
          } else {
            // If multiple locations, fit bounds to show all
            const leafletBounds = L.latLngBounds(bounds);
            map.fitBounds(leafletBounds, { 
              padding: [20, 20],
              maxZoom: 15
            });
          }
        }
      }
    }, [mapData, map]);
    
    return null;
  };

  // Animasyon CSS'lerini eklemek için useEffect
  useEffect(() => {
    if (!document.querySelector('#marker-animations')) {
      const style = document.createElement('style');
      style.id = 'marker-animations';
      style.textContent = `
        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
          40% { transform: translateY(-10px); }
          60% { transform: translateY(-5px); }
        }
        .custom-popup .leaflet-popup-content-wrapper {
          border-radius: 8px;
          box-shadow: 0 8px 25px rgba(0,0,0,0.15);
        }
        .custom-popup .leaflet-popup-tip {
          box-shadow: 0 2px 6px rgba(0,0,0,0.1);
        }
      `;
      document.head.appendChild(style);
    }
  }, []);

  useEffect(() => {
    if (!_id) {
      navigate("/signin");
    } else if (!subscribed) {
      navigate("/signin");
    }
    if (!isNonMobile) {
      setSidebarOpen(false);
    }
  }, []);

  useEffect(() => {
    dispatch(fetchAdminApprovedQoutesLiveProject({ adminID: _id }));
    dispatch(fetchAdminApprovedAdaptionQoutesLiveProject({ adminID: _id }));
    dispatch(fetchJobsForStaffMember());
    dispatch(fetchKeyStaffMember({ adminID: _id }));
    dispatch(adminActions.removeSwalAlert());
    if (isNonMobile) {
      setTimeout(() => {
        $("#table").DataTable({ pagingType: "simple_numbers", retrieve: true });
        $("#table2").DataTable({
          pagingType: "simple_numbers",
          retrieve: true,
        });
      }, 5000);
    }
    console.log(stateadminApprovedAdaptionQoutes, "---------adaption");
  }, []);

  useEffect(() => {
    if (statesignOut === "signOut") {
      dispatch(signOut());
    }
  }, [
    stateApprovedQoutes,
    statekeyMemberStaff,
    jobforStaffMember,
    statesignOut,
  ]);

  const assignStaffMember = (e, b, d) => {
    dispatch(
      assignJobToStaffMember({ jobID: b, staffMemberID: e, qouteID: d })
    );
  };
  const assignStaffMemberAdaption = (e, b, d) => {
    dispatch(
      assignAdaptionToStaffMember({ jobID: b, staffMemberID: e, qouteID: d })
    );
  };
  const deletee = (id) => {
    Swal.fire({
      title: "Do you want to delete the qoutes?",
      text: "All adaptions, dismantles, inspections handovers, etc etc will be deleted with this qoute ! ",
      showDenyButton: true,

      confirmButtonText: "Yes",
      denyButtonText: "No",
      confirmButtonColor: "#66c18a",
      customClass: {
        actions: "my-actions",

        confirmButton: "order-2",
        denyButton: "order-3",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          deleteApproveQoutes({ _id: id, adminID: _id, approved: true })
        ).then(() => {
          dispatch(fetchAdminApprovedQoutesLiveProject({ adminID: _id }));
          dispatch(
            fetchAdminApprovedAdaptionQoutesLiveProject({ adminID: _id })
          );

          // window.location.reload();
        });
      }
    });
  };
  const deleteee = (id) => {
    Swal.fire({
      title: "Do you want to delete the adaption?",
      text: "All adaptions, dismantles, inspections handovers, etc etc will be deleted with this qoute ! ",
      showDenyButton: true,

      confirmButtonText: "Yes",
      denyButtonText: "No",
      confirmButtonColor: "#60c088",
      customClass: {
        actions: "my-actions",

        confirmButton: "order-2",
        denyButton: "order-3",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(
          deleteApproveAdaptionQoutes({
            adaptionID: id,
            adminID: _id,
            approved: true,
          })
        ).then(() => {
          dispatch(fetchAdminApprovedQoutesLiveProject({ adminID: _id }));
          dispatch(
            fetchAdminApprovedAdaptionQoutesLiveProject({ adminID: _id })
          );
        });
      }
    });
  };
  const handleStatusSt = (e, jobID) => {
    e.preventDefault();
    dispatch(jobStatusStart({ jobID: jobID, adminID: _id }));
    dispatch(fetchAdminApprovedQoutesLiveProject({ adminID: _id }));
    //  setTimeout(()=>window.location.reload(true), 3000);
  };

  const handleStatusCm = (jobID) => {
    dispatch(jobStatusComplete({ jobID: jobID, adminID: _id }));
    dispatch(fetchAdminApprovedQoutesLiveProject({ adminID: _id }));
    // setTimeout(()=>window.location.reload(true), 3000);
  };
  const handleStatusSta = (id) => {
    console.log(id);

    dispatch(adaptionStatusStart({ jobID: id, adminID: _id }));
    dispatch(fetchAdminApprovedAdaptionQoutesLiveProject({ adminID: _id }));
  };

  const handleStatusCma = (id) => {
    dispatch(adaptionStatusComplete({ jobID: id, adminID: _id }));
    dispatch(fetchAdminApprovedAdaptionQoutesLiveProject({ adminID: _id }));
  };

  // Function to get status color based on status
  const getStatusColor = (status) => {
    switch (status) {
      case 0:
        return "bg-yellow-100 text-yellow-800"; // pending
      case 1:
        return "bg-blue-100 text-blue-800"; // in progress
      case 2:
        return "bg-green-100 text-green-800"; // completed
      default:
        return "bg-gray-100 text-gray-800";
    }
  };

  // Function to render project card for mobile and desktop view
  const renderProjectCard = (data, isAdaption = false) => {
    const today = moment().format("DD-MM-YYYY");
    const inspectionDate = moment(
      moment(data.nextInspectionDate).add(7, "d").format("DD-MM-YYYY")
    )._i;
    const newDate = moment(new Date(data.dateOfErection)).format("DD-MM-YYYY");
    const dismantleDate = isAdaption
      ? ""
      : moment(new Date(data.dismantleRequestedDate)).format("DD-MM-YYYY");

    const jobID = isAdaption ? data.adaptionID : data.jobID;
    const statusClass = getStatusColor(jobID.status);

    return (
      <div
        key={jobID._id}
        id={`project-${jobID._id}`}
        className="bg-white rounded border border-gray-200 shadow-sm mb-2 overflow-hidden hover:shadow-md"
      >
        {/* Header */}
        <div className="bg-[#66c18a] px-3 py-1 flex justify-between items-center">
          <h3 className="text-white font-medium text-sm truncate">
            {data.customerID.customerCompanyName}
          </h3>
          <span
            className={`px-2 py-0.5 rounded-full text-xs font-semibold ${statusClass}`}
          >
            {jobID.status === 0
              ? "Pending"
              : jobID.status === 1
              ? "In Progress"
              : "Completed"}
          </span>
        </div>

        {/* Main content in a table-like layout */}
        <div className="px-3 py-2">
          {/* Top row with key details */}
          <div className="flex justify-between mb-1.5 text-xs">
            <div className="flex items-center">
              <span className="text-gray-600 font-medium mr-1">ID:</span>
              <span className="font-semibold text-gray-800 mr-4">{jobID.jobNumber}</span>
              
              <span className="text-gray-600 font-medium mr-1">Weeks:</span>
              <span className="font-semibold text-gray-800">
                {isAdaption ? data.numberOfWeeks : data.numberOfWeekRequired}
              </span>
            </div>
            
            <div className="flex items-center">
              <span className="text-gray-600 font-medium mr-1">Date:</span>
              <span className="font-semibold text-gray-800 mr-4">{newDate}</span>
              
              <span className="text-gray-600 font-medium mr-1">Insp:</span>
              <span className={`font-semibold ${today === inspectionDate ? "text-red-600" : "text-gray-800"}`}>
                {data.WeeklyScaffoldingInspections || data.weeklyScoffoldingInspectionSwitch
                  ? inspectionDate
                  : "Not needed"}
              </span>
            </div>
          </div>
          
          {/* Address */}
          <div className="flex items-start mb-1 text-xs">
            <span className="text-gray-600 font-medium mr-1 w-14">Address:</span>
            <span className="font-semibold text-gray-800 truncate flex-1">
              {jobID.job1} {jobID.job2}
            </span>
          </div>
          
          {/* Description */}
          <div className="flex items-start mb-1 text-xs">
            <span className="text-gray-600 font-medium mr-1 w-14">Desc:</span>
            <span className="text-gray-800 truncate flex-1">
              {isAdaption ? jobID.adaptionDetails : jobID.jobDescription}
            </span>
          </div>
          
          {/* Dismantle information */}
          {!isAdaption && (
            <div className="flex items-start mb-1 text-xs">
              <span className="text-gray-600 font-medium mr-1 w-14">Dismantle:</span>
              <span className="text-gray-800 truncate flex-1">
                {data.partialDismantleDescription || "N/A"}
              </span>
              <span className="text-gray-600 font-medium mr-1 ml-2">Date:</span>
              <span className="font-semibold text-gray-800 w-24">
                {dismantleDate || "Invalid date"}
              </span>
            </div>
          )}

          {/* Bottom row with actions */}
          <div className="flex justify-between items-center mt-2 pt-1.5 border-t border-gray-100">
            {/* Staff selection */}
            <div className="flex items-center text-xs">
              <span className="text-gray-600 font-medium mr-1">Staff:</span>
              <select
                name="staff"
                onChange={(e) =>
                  isAdaption
                    ? assignStaffMemberAdaption(e.target.value, jobID._id)
                    : assignStaffMember(e.target.value, jobID._id)
                }
                className="py-0.5 px-1 border rounded text-xs bg-gray-50"
              >
                <option value="">Select</option>
                {statekeyMemberStaff.map((staff) => (
                  <option
                    key={staff._id}
                    value={staff._id}
                    selected={jobID.staffMemberID === staff._id}
                  >
                    {staff.fullName}
                  </option>
                ))}
              </select>
              
              {/* Status button */}
              <div className="ml-3">
                {jobID.status === 0 ? (
                  <button
                    onClick={(e) =>
                      isAdaption
                        ? handleStatusSta(jobID._id)
                        : handleStatusSt(e, jobID._id)
                    }
                    className="bg-[#66c18a] text-white py-0.5 px-3 rounded text-xs font-medium hover:bg-[#5ab17d]"
                  >
                    Start
                  </button>
                ) : jobID.status === 1 ? (
                  <button
                    onClick={() =>
                      isAdaption
                        ? handleStatusCma(jobID._id)
                        : handleStatusCm(jobID._id)
                    }
                    className="bg-[#66c18a] text-white py-0.5 px-3 rounded text-xs font-medium hover:bg-[#5ab17d]"
                  >
                    Complete
                  </button>
                ) : (
                  <button
                    className="bg-gray-200 text-gray-700 py-0.5 px-3 rounded text-xs font-medium cursor-not-allowed"
                    disabled
                  >
                    Done
                  </button>
                )}
              </div>
            </div>
            
            {/* Action buttons in a row */}
            <div className="flex space-x-4 items-center">
              <div
                className="flex items-center cursor-pointer group"
                onClick={() =>
                  navigate(
                    isAdaption
                      ? `/adaptionhandover?adaptionID=${jobID._id}&id=${data.customerID._id}&clientName=${data.customerID.customerCompanyName}&address=${jobID.job1}&postcode=${jobID.postCode}&adminname=${data.adminID.fullName}&adminemail=${data.adminID.email}`
                      : `/form?id=${data.customerID._id}&clientName=${data.customerID.customerCompanyName}&address=${jobID.job1}&postcode=${jobID.postCode}&adminname=${data.adminID.fullName}&adminemail=${data.adminID.email}`
                  )
                }
              >
                <PanToolIcon
                  sx={{ width: "20px", height: "20px" }}
                  className={`${
                    jobID.status === 2 ? "text-green-600" : "text-[#66c18a]"
                  } group-hover:text-[#5ab17d]`}
                />
                <span className="text-xs ml-1 font-medium">Handover</span>
              </div>

              <div
                className="flex items-center cursor-pointer group"
                onClick={() =>
                  navigate(
                    isAdaption
                      ? `/scaffoldinginspectionsadaption?adaptionID=${
                          jobID._id
                        }&cutomerName=${
                          data.customerID.customerCompanyName
                        }&cutomerAddress=${
                          data.customerID.address
                        }&siteAddress=${jobID.job1 + jobID.job2}&customerID=${
                          data.customerID._id
                        }&jobID=${data.jobID._id}&type=${
                          data.type === "escaffQoute"
                            ? "escaffQoute"
                            : "temproof"
                        }`
                      : `/scaffoldinginspections?cutomerName=${
                          data.customerID.customerCompanyName
                        }&cutomerAddress=${
                          data.customerID.address
                        }&siteAddress=${
                          jobID.job1 + " " + jobID.job2
                        }&customerID=${data.customerID._id}&jobID=${
                          jobID._id
                        }&type=${
                          data.type === "escaffQoute"
                            ? "escaffQoute"
                            : "temproof"
                        }`
                  )
                }
              >
                <UpdateIcon
                  sx={{ width: "20px", height: "20px" }}
                  className={`${
                    today === inspectionDate ? "text-red-600" : "text-[#66c18a]"
                  } group-hover:text-[#5ab17d]`}
                />
                <span className="text-xs ml-1 font-medium">Inspection</span>
              </div>

              {!isAdaption && (
                <div
                  className="flex items-center cursor-pointer group"
                  onClick={() => navigate(`/dismantle?id=${jobID._id}`)}
                >
                  <HomeWorkIcon
                    sx={{ width: "20px", height: "20px" }}
                    className={`${
                      data.completeDismantle ? "text-red-500" : "text-[#66c18a]"
                    } group-hover:text-[#5ab17d]`}
                  />
                  <span className="text-xs ml-1 font-medium">Dismantle</span>
                </div>
              )}

              <div
                className="flex items-center cursor-pointer group"
                onClick={() =>
                  isAdaption ? deleteee(data._id) : deletee(data._id)
                }
              >
                <DeleteIcon
                  sx={{ width: "20px", height: "20px" }}
                  className="text-[#66c18a] group-hover:text-red-500"
                />
                <span className="text-xs ml-1 font-medium">Delete</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="w-full h-full">
      <HeaderScaff setSidebarOpen={setSidebarOpen} />
      <div className={`w-full flex ${!isNonMobile && !sidebarOpen ? "flex-col" : ""} h-auto p-2 sm:p-6`}>
        <div className={`${sidebarOpen ? (isNonMobile ? "basis-1/5" : "flex justify-center w-full") : "hidden"} w-full h-full`}>
          <Sidebar setSidebarOpen={setSidebarOpen} needed={needed} isNonMobile={isNonMobile} />
        </div>

        <div
          onClick={() => setSidebarOpen(true)}
          className={`${sidebarOpen ? (isNonMobile ? "hidden" : "hidden") : (isNonMobile ? "flex w-12 mt-4" : "flex border-2 border-x-0 bg-gray-100/50 mt-2 -mb-1 w-full items-center justify-center")} h-fit`}
        >
          <div className={`${sidebarOpen ? (isNonMobile ? "" : "") : (isNonMobile ? "" : "hidden")}`}>
            <IconButton onClick={() => setSidebarOpen(true)}>
              <ArrowForwardIosIcon />
            </IconButton>
          </div>
          <div className={`${sidebarOpen ? (isNonMobile ? "hidden" : "hidden") : (isNonMobile ? "hidden" : "flex")}`}>
            <p className="text-gray-500 text-xs py-[2px]">Sidebar</p>
          </div>
        </div>

        <div className={`${sidebarOpen ? (isNonMobile ? "basis-4/5 flex flex-col ml-4 md:pt-4" : "hidden") : "w-full flex flex-col pl-3 pt-3"}`}>
          {/* Map Section */}
          <div className="w-full mb-6">
            <div className="flex justify-between items-center mb-4">
              <div className="flex items-center space-x-2">
                <MapIcon className="text-[#66c18a]" />
                <h2 className="text-lg md:text-xl xxl:text-2xl text-slate-600 font-medium">
                  Project Locations
                </h2>
                {showMap && !mapLoading && (
                  <span className="bg-[#66c18a] text-white text-xs px-2 py-1 rounded-full">
                    {mapData.reduce((total, cluster) => total + cluster.projectCount, 0)} Projects
                  </span>
                )}
                {mapLoading && (
                  <span className="bg-gray-400 text-white text-xs px-2 py-1 rounded-full">
                    Loading...
                  </span>
                )}
              </div>
              
              <button
                onClick={handleMapToggle}
                disabled={mapLoading}
                className="flex items-center space-x-2 px-3 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {mapLoading ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-2 border-gray-500 border-t-transparent"></div>
                    <span className="text-sm font-medium">Loading...</span>
                  </>
                ) : showMap ? (
                  <>
                    <VisibilityOffIcon fontSize="small" />
                    <span className="text-sm font-medium">Hide Map</span>
                  </>
                ) : (
                  <>
                    <VisibilityIcon fontSize="small" />
                    <span className="text-sm font-medium">Show Map</span>
                  </>
                )}
              </button>
            </div>

            {showMap && (
              <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                {mapLoading ? (
                  <div className="w-full h-96 flex items-center justify-center bg-gray-50">
                    <div className="text-center">
                      <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#66c18a] border-t-transparent mx-auto mb-4"></div>
                      <h3 className="text-lg font-medium text-gray-700 mb-2">Loading Map Data</h3>
                      <p className="text-sm text-gray-500">Fetching project locations and focusing map...</p>
                    </div>
                  </div>
                ) : mapData.length === 0 ? (
                  <div className="w-full h-96 flex items-center justify-center bg-gray-50">
                    <div className="text-center">
                      <MapIcon className="text-gray-400 mx-auto mb-4" style={{ fontSize: 48 }} />
                      <h3 className="text-lg font-medium text-gray-700 mb-2">No Location Data</h3>
                      <p className="text-sm text-gray-500">No projects with location information found.</p>
                    </div>
                  </div>
                ) : (
                  <>
                    <MapContainer
                      center={[54.5, -3]}
                      zoom={6}
                      style={{ height: '550px', width: '100%' }}
                      className="w-full h-96"
                    >
                      <TileLayer
                        url="https://tile.openstreetmap.org/{z}/{x}/{y}.png"
                        crossOrigin="true"
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                      />
                      
                      {/* Map controller for automatic focusing */}
                      <MapController mapData={mapData} />
                      
                      {/* Proje marker'larını render et */}
                      {mapData.map((cluster) => {
                        if (cluster.coordinates && cluster.coordinates.latitude && cluster.coordinates.longitude) {
                          const uniqueKey = `${cluster.coordinates.latitude}-${cluster.coordinates.longitude}`;
                          return (
                            <Marker
                              key={uniqueKey}
                              position={[cluster.coordinates.latitude, cluster.coordinates.longitude]}
                              icon={createCustomMarkerIcon(cluster)}
                              eventHandlers={{
                                click: (e) => {
                                  // Bounce animasyonu ekle
                                  const markerElement = e.target._icon;
                                  if (markerElement) {
                                    markerElement.style.animation = 'none';
                                    void markerElement.offsetHeight;
                                    markerElement.style.animation = 'bounce 0.6s ease';
                                  }
                                }
                              }}
                            >
                              <Popup
                                maxWidth={cluster.projectCount > 1 ? 320 : 280}
                                className="custom-popup"
                              >
                                <div dangerouslySetInnerHTML={{ __html: createPopupContent(cluster) }} />
                              </Popup>
                            </Marker>
                          );
                        }
                        return null;
                      })}
                    </MapContainer>
                    
                    <div className="bg-gray-50 px-4 py-3 border-t border-gray-200">
                      <div className="flex flex-wrap items-center justify-between gap-4">
                        <div className="flex items-center space-x-6">
                          <div className="flex items-center space-x-2">
                            <div className="w-4 h-4 bg-yellow-200 border-2 border-yellow-500 rounded-full flex items-center justify-center text-xs">
                              ⏳
                            </div>
                            <span className="text-sm text-gray-600">Pending</span>
                          </div>
                          
                          <div className="flex items-center space-x-2">
                            <div className="w-4 h-4 bg-blue-200 border-2 border-blue-500 rounded-full flex items-center justify-center text-xs">
                              🔄
                            </div>
                            <span className="text-sm text-gray-600">In Progress</span>
                          </div>
                          
                          <div className="flex items-center space-x-2">
                            <div className="w-4 h-4 bg-green-200 border-2 border-green-500 rounded-full flex items-center justify-center text-xs">
                              ✅
                            </div>
                            <span className="text-sm text-gray-600">Completed</span>
                          </div>
                          
                          <div className="flex items-center space-x-2">
                            <div className="w-4 h-4 bg-red-200 border-2 border-red-600 rounded-full flex items-center justify-center text-xs">
                              🔨
                            </div>
                            <span className="text-sm text-gray-600">Dismantle Needed</span>
                          </div>
                        </div>
                        
                        <div className="text-xs text-gray-500">
                          Click markers for project details • {mapData.reduce((total, cluster) => total + cluster.projectCount, 0)} projects in {mapData.length} locations
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
          </div>

          {/* Live Projects Section */}
          <div className="w-full mb-8">
            <div className="flex space-x-2 mb-4">
              <p className="text-base md:text-xl xxl:text-2xl text-slate-600 font-medium pb-1 ml-2 hover:text-black cursor-pointer whitespace-nowrap">
                Your live projects
                <CircleIcon
                  sx={{ width: "17px", height: "17px" }}
                  className="text-green-600 ml-1"
                />
              </p>
          </div>

            <div className="w-full px-2">
            {stateApprovedQoutes.length === 0 ? (
                <p className="text-center text-gray-500 my-4">
                No live projects available
              </p>
            ) : (
              stateApprovedQoutes.map((data) => renderProjectCard(data))
            )}
            </div>
          </div>

          {/* Adaptions Section */}
          <div className="w-full">
            <div className="flex space-x-2 mb-4">
              <p className="text-base md:text-xl xxl:text-2xl text-slate-600 font-medium pb-1 ml-2 hover:text-black cursor-pointer whitespace-nowrap">
                Your Adaptions
                <CircleIcon
                  sx={{ width: "17px", height: "17px" }}
                  className="text-green-600 ml-1"
                />
              </p>
          </div>

            <div className="w-full px-2">
              {stateadminApprovedAdaptionQoutes.length === 0 ? (
                <p className="text-center text-gray-500 my-4">
                  No adaptions available
                </p>
              ) : (
                stateadminApprovedAdaptionQoutes.map((data) =>
                  renderProjectCard(data, true)
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LiveProjects;